import { combineReducers } from "redux";
import { AsipProfile } from "../../models/users";
import {
  createReducerWithTaskName,
  createSimpleReducer,
  INITIAL_STATE_EMPTY_TASK,
  TaskState,
} from "../../utils/reducers";
import {
  CLEAR_ASIP_REDUCER,
  SET_ASIP_PROFILE,
  UPDATE_ASIP_PROFILE,
} from "./constants";

export const defaultAsipProfile: AsipProfile = {
  asip_profile_id: "",
  asip_status: "not_started",
  date_created: new Date().getTime(),
  date_started: new Date().getTime(),
  date_last_updated: new Date().getTime(),
  date_completed: new Date().getTime(),
  date_sdm_pdf_last_generated: new Date().getTime(),
  date_dr_pdf_last_generated: new Date().getTime(),
  is_primary_profile: false,
  user_id: "",
  demographics: {
    children: "",
    city: "",
    country: "",
    state: "",
    date_of_birth: "",
    first_name: "",
    gender: "",
    health_concerns: "",
    last_name: "",
    marital_status: "",
    quality_of_life: "",
    referral_sources: [],
  },

  current_page: "intro",
  completed_pages: [],
  progress: {
    percentage_completed: 0,
    pages: {
      intro: {
        percentage_completed: 0,
        current_section: 0,
      },
      values: {
        percentage_completed: 0,
        current_section: 0,
      },
      demographics: {
        percentage_completed: 0,
        current_section: 0,
      },
      care: {
        percentage_completed: 0,
        current_section: 0,
      },
      decisions: {
        percentage_completed: 0,
        current_section: 0,
      },
      incapacitated: {
        percentage_completed: 0,
        current_section: 0,
      },
      preferences: {
        percentage_completed: 0,
        current_section: 0,
      },
      sdm: {
        percentage_completed: 0,
        current_section: 0,
      },
    },
  },

  plan_for_medical_care_quiz: null,
  completed_from: "",

  values_q1: 0,
  values_q2: 0,
  values_confirm_description: "",
  values_confirm_quiz: "",

  care_progress: {
    comfort: false,
    intensive: false,
    medical: false,
  },
  care_review_selection: "",
  cpr_quiz_answers: [],
  cpr_quiz_score: 0,
  types_of_care_quiz_answers: [],
  types_of_care_quiz_score: 0,
  long_term_care_setting: false,

  addtl_comments: "",
  meaning_short_term: "",
  worse_than_death: "",
  preferences_q3: 0,
  preferences_q4: 0,
  preferences_surety_reasoning: "",
  preferences_surety_context: "",
  preferences_surety_quiz: 0,
  preferences_confirm_description: "",
  preferences_confirm_quiz: "",
  preference_is_unsure: true,
  preference_finalized: "",

  decisions_q5: 0,
  decisions_q6: 0,

  sdm_wishes: "",
  sdm_email: "",
  sdm_name: "",
  sdm_phone: "",

  sdm_has_documents: "",
  sdm_has_details: "",
  sdm_is_designated: "",
  sdm_is_educated: "",
  sdm_sent_email: "",
  sdm_sent_reminder: "",
  sdm_submitted_name: "",
  sdm_confidence: 0,
};

export const ASIP_INITIAL_STATE: {
  profile: AsipProfile;
  updateProfile: TaskState;
  loadProfile: TaskState;
} = {
  profile: {
    ...defaultAsipProfile,
  },
  updateProfile: { ...INITIAL_STATE_EMPTY_TASK },
  loadProfile: { ...INITIAL_STATE_EMPTY_TASK, loading: true },
};

const asipRootReducer = combineReducers({
  profile: createSimpleReducer(SET_ASIP_PROFILE, ASIP_INITIAL_STATE.profile),
  updateProfile: createReducerWithTaskName(
    UPDATE_ASIP_PROFILE,
    ASIP_INITIAL_STATE.updateProfile
  ),
  loadProfile: createReducerWithTaskName(
    SET_ASIP_PROFILE,
    ASIP_INITIAL_STATE.loadProfile
  ),
});

const asipReducer = (state: any, action: any) => {
  if (action.type === CLEAR_ASIP_REDUCER) {
    state = {
      ...ASIP_INITIAL_STATE,
    };
  }
  return asipRootReducer(state, action);
};

export default asipReducer;
